import type { Pronunciation } from 'js/src/client';

export type PronunciationIDType = Pronunciation['id'];

export type UpdatedPronunciation = {
    id: PronunciationIDType;
    pronunciation: Pronunciation['pronunciation'];
};

// the same regex in the backend to clean words is in pronunciation.py
export const STRIPPED_PUNCTUATIONS_REGEX = /[!"#$&'()*+,-./:;<=>?@[\\\]^_`{|}~]/;
export const MAX_PRONUNCIATION_WORDS = 3;

/** Why a selection's pronunciation cannot be edited. */
export enum PRONUNCIATION_SELECTION_ISSUES {
    /** Nothing editable is selected: no words, or only silence, trimmed-out or non-word nodes */
    UNSUPPORTED_SELECTION = 'unsupported-selection',
    /** More than MAX_PRONUNCIATION_WORDS words are selected */
    TOO_MANY_WORDS = 'too-many-words',
    /** Editing would grow an existing override past MAX_PRONUNCIATION_WORDS words */
    EXTENDS_OVERRIDE = 'extends-override',
}

export const PronunciationLibraryColumnIds = {
    WordSlashPhrase: 'Word-Phrase',
    Pronunciation: 'Pronunciation',
    Language: 'Language',
    Action: 'Action',
};
